



























































































































































































































































































































import DraggableWidget from '@/components/util/DraggableWidget.vue';
import WorkOrderListView from '@/components/orders/WorkOrderListView.vue';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  Property,
  Workorder,
  PerformoSettings,
  User,
  QueryWorkOrdersRequest
} from 'performo-api';
import { SortChangedEvent } from '@/models/SortChangedEvent';

@Component({
  components: { DraggableWidget, WorkOrderListView }
})
export default class MyOrdersWidget extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop() private widgetConfiguration: any;

  private paginationSkip = 0;

  private ordersQuery!: QueryWorkOrdersRequest;
  private orderStatusQuery!: string;
  private showModal = false;
  private allEntitiesFilterChecked!: boolean;
  private allUsersOrdersFilterChecked!: boolean;
  private entryDateRange: Date[] = [];

  data() {
    return {
      ordersQuery: undefined,
      allEntitiesFilterChecked: undefined,
      allUsersOrdersFilterChecked: undefined,
      entrydateRange: undefined,
      orderStatusQuery: undefined
    };
  }

  get performoSettings(): PerformoSettings {
    return this.$store.getters.settings;
  }
  get currentProperty(): Property {
    return this.$store.getters.currentProperty;
  }
  get currentUser(): User {
    return this.$store.getters.performoUser;
  }
  get floorLabel() {
    return this.currentProperty.floorLabel
      ? this.currentProperty.floorLabel
      : 'Floor';
  }

  private display = this.performoSettings.enableCampuses
    ? [
        {
          displayName: 'Request #',
          columnName: 'requestId',
          width: 'auto'
        },
        {
          displayName: 'Work Order #',
          columnName: 'orderNumber',
          width: 'auto'
        },
        {
          displayName: 'Entry Date',
          columnName: 'entryTimestampLTZ',
          formatKind: 1,
          width: 'auto'
        },
        { displayName: 'Status', columnName: 'orderStatus', width: 'auto' },
        { displayName: 'Order By', columnName: 'orderBy', width: 'auto' },
        {
          displayName: this.performoSettings.campusLabelSingular || 'Campus',
          columnName: 'campus',
          width: 'auto'
        },
        {
          displayName: this.currentProperty.location1Label || 'Building',
          columnName: 'building',
          width: 'auto'
        },
        {
          displayName: this.currentProperty.location2Label || 'Room',
          columnName: 'suite',
          width: 'auto'
        }
      ]
    : [
        {
          displayName: 'Request #',
          columnName: 'requestId',
          width: 'auto'
        },
        {
          displayName: 'Work Order #',
          columnName: 'orderNumber',
          width: 'auto'
        },
        {
          displayName: 'Entry Date',
          columnName: 'entryTimestampLTZ',
          formatKind: 1,
          width: 'auto'
        },
        { displayName: 'Status', columnName: 'orderStatus', width: 'auto' },
        { displayName: 'Order By', columnName: 'orderBy', width: 'auto' },
        {
          displayName: this.currentProperty.location1Label || 'Building',
          columnName: 'building',
          width: 'auto'
        },
        {
          displayName: this.currentProperty.location2Label || 'Room',
          columnName: 'suite',
          width: 'auto'
        },
        { displayName: 'Status', columnName: 'orderStatus', width: 'auto' },
        { displayName: 'Order By', columnName: 'orderBy', width: 'auto' }
      ];

  @Watch('currentProperty')
  private onCurrentPropertyChanged() {
    this.handleFilterReset();
  }

  @Watch('allEntitiesFilterChecked')
  private onAllEntitiesFilterCheckedChanged() {
    if (this.allEntitiesFilterChecked) {
      this.ordersQuery.propertyId = 'All';
    } else if (this.currentProperty.propertyId) {
      this.ordersQuery.propertyId = this.currentProperty.propertyId;
    }
    this.updateSkip();
  }

  @Watch('entryDateRange')
  private onEntryDateRangeChanged(dates: Date[]) {
    if (dates) {
      this.ordersQuery = {
        ...this.ordersQuery,
        entryDateStart: dates[0],
        entryDateEnd: dates[1]
      };
    } else {
      this.ordersQuery = {
        ...this.ordersQuery,
        entryDateStart: undefined,
        entryDateEnd: undefined
      };
    }
  }

  @Watch('orderStatusQuery')
  private onOrderStatusQueryChanged() {
    this.ordersQuery = {
      ...this.ordersQuery,
      orderStatus: this.orderStatusQuery === 'All' ? '' : this.orderStatusQuery
    };
    this.updateSkip();
  }

  private handleFilterReset() {
    this.allEntitiesFilterChecked = false;
    this.allUsersOrdersFilterChecked = false;
    this.entryDateRange = [];
    this.orderStatusQuery = 'Open';
    const q: QueryWorkOrdersRequest = {
      propertyId: this.currentProperty.propertyId
        ? this.currentProperty.propertyId
        : 'All',
      orderStatus: 'Open',
      sortColumn: 'entryTimestampLTZ',
      sortDirection: 'descend',
      skip: 0
    };
    this.ordersQuery = q;
  }

  private orderClickedHandler(order: Workorder) {
    if (order.workorderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: order.workorderId }
      });
    }
  }

  private paginationSkipUpdatedHandler(skip: number) {
    this.updateSkip(skip);
  }

  private updateSkip(skip?: number) {
    this.ordersQuery = {
      ...this.ordersQuery,
      skip: skip ? skip : 0
    };
  }

  private sortChangedHandler(sort: SortChangedEvent) {
    this.ordersQuery = {
      ...this.ordersQuery,
      sortColumn: sort.column,
      sortDirection: sort.direction === 1 ? 'ascend' : 'descend'
    };
    this.updateSkip();
  }

  private created() {
    this.handleFilterReset();
  }

  private doWorkOrderList() {
    // blank
  }
}

Vue.component('MyOrdersWidget', MyOrdersWidget);
